import { MapRepository } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import { ConsistencyLink } from './ConsistencyLink';
import type { ConsistencyLinkCollectionJSON } from './ConsistencyLinkCollection';
import { ConsistencyLinkCollection } from './ConsistencyLinkCollection';
import type { ConsistencyLinkJSON, ViewModelId } from 'balus-common';

export type ConsistencyLinkMapRepository = MapRepository<
  ConsistencyLinkJSON,
  ConsistencyLink,
  ConsistencyLinkCollectionJSON,
  ConsistencyLinkCollection
>;

export const createConsistencyLinkMapRepository = (viewModelId: ViewModelId): ConsistencyLinkMapRepository => {
  return new MapRepository(ConsistencyLink, ConsistencyLinkCollection, RTDBPath.ConsistencyLink.linksPath(viewModelId));
};
